{
  "id": 46,
  "location": "paris",
  "difficulty": "normal",
  "moves": 33,
  "kinds": 6,
  "goals": [
    { "type": "collect", "kind": "croissant", "count": 36 },
    { "type": "collect", "kind": "donut", "count": 36 }
  ],
  "stars": [4000, 4870],
  "board": [
    "# # # . . # # #",
    "# # . . . . # #",
    "# . . . . . . #",
    ". . . . . . . .",
    ". . . . . . . .",
    "# . . . . . . #",
    "# # . . . . # #",
    "# # # . . # # #"
  ],
  "calibration": { "runs": 1000, "winRate": 0.724, "movesLeft": 5.9, "closeLosses": 0.125, "target": 0.68 }
}
